import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import News from './components/The daily lingo/News';
import SeoHead from './components/SeoHead';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <SeoHead />
      <Routes>
        <Route path="/" element={<News />} />
        <Route path="/edition/:dateKey" element={<News />} />
      </Routes>
    </Router>
  );
}

export default App;
